import React from 'react';
import cn from 'classnames';

import classes from './icon.module.scss';
import { FONT_GLYPHS, SVG_GLYPHS, ICON_SIZES } from './types';

type IconProps = {
  iconClassName?: string;
  glyph: FONT_GLYPHS | SVG_GLYPHS,
  size: ICON_SIZES,
  onClick?: (e: React.SyntheticEvent) => void;
};

const Icon = (props: IconProps): JSX.Element => {
  let icon = null;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const fontGlyph = FONT_GLYPHS[props.glyph];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const svgGlyph = SVG_GLYPHS[props.glyph];

  if (fontGlyph) {
    const fontIconClassName = cn(
      'pi',
      fontGlyph,
      classes.icon,
      classes[ICON_SIZES[props.size]],
      props.iconClassName
    );

    icon = <i className={fontIconClassName} />;
  } else if(svgGlyph) {
    const SVGIconClassName = cn(classes.icon, props.iconClassName, classes[ICON_SIZES[props.size]]);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const SVGIcon = require.context('!raw-loader!./svg', true, /^\.\/.*\.svg$/)(`./${SVG_GLYPHS[props.glyph]}.svg`);
    icon = <i dangerouslySetInnerHTML={{__html: SVGIcon?.default}}  onClick={props.onClick} className={SVGIconClassName} />
  }

  return <>{icon}</>
};

Icon.glyphs = { font: FONT_GLYPHS, svg: SVG_GLYPHS };

Icon.sizes = ICON_SIZES;

Icon.defaultProps = {
  size: ICON_SIZES.small
};

export { Icon, IconProps };
